
import { NodeActionsProps } from '@/pages/User/pages/Home/components/TreePanel/components/NodeActions/types'
import { FrozenIcon, LockedIcon } from '@/utils/node-action-icons'

import { NodeActionsWrapper } from './styles'

export const NodeActions = ({ node }: NodeActionsProps) => {
	return (
		<NodeActionsWrapper>
			<FrozenIcon status={node.node.status} />
			<LockedIcon node={node.node} />
		</NodeActionsWrapper>
	)
}
